import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 9rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20rem;
`;

export const Text = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 20rem;
    gap: 40rem;
  `,

  Container: styled.div``,
  Number: styled.div`
    & > span {
      color: #2a4cff;
    }
    font-weight: 450;
    font-size: 2rem;
  `,
  Title: styled.div`
    font-size: 4rem;
    font-weight: bold;
    margin-top: 1rem;
  `,
  Text: styled.div`
    color: #666;
    font-size: 1.8rem;
    margin-top: 2rem;
    width: 43rem;
    line-height: 2.8rem;
  `,

  ListText: styled.div`
    color: #666;
    font-size: 1.8rem;
    margin-top: 2rem;
    width: 43rem;
  `,
};

export const Line = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    padding-top: 25rem;
    gap: 52rem;
    & > img {
      top: 0;
      position: absolute;
      height: 410rem;
    }

    & > div {
      font-size: 2rem;
      border-radius: 1.7rem;
      border: 0.1rem solid #bbb;
      background: #fff;
      padding: 0.3rem 1rem;
      z-index: 2;
    }
  `,
};

export const Imgs = {
  Wrapper: styled.div`
    padding-top: 1.7rem;
    display: flex;
    flex-direction: column;
    gap: 9.1rem;

    & > img {
      width: 46rem;
      height: 46rem;
    }
  `,
};
